module.exports = __webpack_public_path__ + "static/img/contact.817b4549.png";